import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthScene } from '@/versions/v1/modules/auth/AuthScene';
import { LobbyDeclinedScene, LobbyScene } from '@/versions/v1/modules/auth/LobbyScene';
import { SignupScene } from '@/versions/v1/modules/auth/SignupScene';
import { DocsLibraryScene } from '@/versions/v1/modules/docs-library/DocsLibraryScene';
import { ChangelogScene } from '@/versions/v1/modules/changelog/ChangelogScene';
import { NotFoundScene } from '@/versions/v1/modules/NotFoundScene';
// fork: imports — issues (P3b)
import { AlertsScene } from '@/versions/v1/modules/issues/AlertsScene';
import { IncidentsScene } from '@/versions/v1/modules/issues/IncidentsScene';
import { IssuesLiveScene } from '@/versions/v1/modules/issues/IssuesLiveScene';
import { RoutingScene } from '@/versions/v1/modules/issues/RoutingScene'; // fork(oem/v1.8)
import { ConnectorDetailScene } from '@/versions/v1/modules/settings/ConnectorDetailScene';
import { PluginDetailScene } from '@/versions/v1/modules/settings/PluginDetailScene';
import { PluginMarketplaceScene } from '@/versions/v1/modules/settings/PluginMarketplaceScene';
import { PluginSkillDetailScene } from '@/versions/v1/modules/settings/PluginSkillDetailScene';
import { PluginsScene } from '@/versions/v1/modules/settings/PluginsScene';
import { ProjectSettingsScene } from '@/versions/v1/modules/settings/ProjectSettingsScene';
import { SettingsRoute } from '@/versions/v1/modules/settings/SettingsRoute';
import { SkillDetailScene } from '@/versions/v1/modules/settings/SkillDetailScene';
import { AdminDashboardScene } from '@/versions/v1/modules/admin/AdminDashboardScene';
import { AgentReviewInlineScene } from '@/versions/v1/modules/admin/AgentReviewInlineScene';
import { ApiKeysScene } from '@/versions/v1/modules/admin/ApiKeysScene';
import { ConnectorsScene } from '@/versions/v1/modules/admin/ConnectorsScene';
import { EditorPageFlowScene } from '@/versions/v1/modules/admin/EditorPageFlowScene';
import { EmbeddingProviderScene } from '@/versions/v1/modules/admin/EmbeddingProviderScene';
import { PredefinedSkillsScene } from '@/versions/v1/modules/admin/PredefinedSkillsScene';
import { ProjectsScene } from '@/versions/v1/modules/admin/ProjectsScene';
import { SandboxLibrariesScene } from '@/versions/v1/modules/admin/SandboxLibrariesScene';
import { ServiceHealthScene } from '@/versions/v1/modules/admin/ServiceHealthScene';
import { SignupsScene } from '@/versions/v1/modules/admin/SignupsScene';
import { SystemPromptScene } from '@/versions/v1/modules/admin/SystemPromptScene';
import { AiModelsScene } from '@/versions/v1/modules/admin/AiModelsScene';
import { BuiltinToolsScene } from '@/versions/v1/modules/admin/BuiltinToolsScene';
import { MaintenanceScene } from '@/versions/v1/modules/admin/MaintenanceScene';
import { SsoScene } from '@/versions/v1/modules/admin/SsoScene';
import { SystemStatusScene } from '@/versions/v1/modules/admin/SystemStatusScene';
import { UsersScene } from '@/versions/v1/modules/admin/UsersScene';
import { AnnouncementBannerScene } from '@/versions/v1/modules/admin/AnnouncementBannerScene';
import { WorkspaceScene } from '@/versions/v1/modules/admin/WorkspaceScene';
import { PortfolioScene } from '@/versions/v1/modules/projects/PortfolioScene';
import { ProjectChatScene } from '@/versions/v1/modules/projects/ProjectChatScene';
import { ProjectHomeScene } from '@/versions/v1/modules/projects/ProjectHomeScene';
import { ProjectWorkflowsScene } from '@/versions/v1/modules/projects/ProjectWorkflowsScene';
import { ProjectEditorScene } from '@/versions/v1/modules/projects/ProjectEditorScene';
import { ProjectDashboardsScene } from '@/versions/v1/modules/projects/ProjectDashboardsScene';
import { ProjectTasksScene } from '@/versions/v1/modules/projects/ProjectTasksScene';
import { Asset360Scene } from '@/versions/v1/modules/asset360/Asset360Scene';
import { ApprovalsScene } from '@/versions/v1/modules/approvals/ApprovalsScene';
import { CostSummaryScene } from '@/versions/v1/modules/costs/CostSummaryScene';
// fork: scenes — fleet/sites (P3c)
import { FleetHealthScene } from '@/versions/v1/modules/fleet/FleetHealthScene';
import { MachineScene } from '@/versions/v1/modules/fleet/MachineScene';
// fork(oem/v1.8): the A$ driver tree — which machine to target first.
import { PrioritiesScene } from '@/versions/v1/modules/fleet/PrioritiesScene';
import { MineSiteScene } from '@/versions/v1/modules/sites/MineSiteScene';
import { SitesMapScene } from '@/versions/v1/modules/sites/SitesMapScene';
// fork: scenes — loops/jobs (P5b)
import { LoopScene } from '@/versions/v1/modules/loops/LoopScene';
import { LoopsSectionScene } from '@/versions/v1/modules/loops/LoopsSectionScene';
import { CaseTraceScene } from '@/versions/v1/modules/jobs/CaseTraceScene';
import { JobBoardScene } from '@/versions/v1/modules/jobs/JobBoardScene';
import { JobCardsScene } from '@/versions/v1/modules/jobs/JobCardsScene';
// fork: scenes — workflows (P5a)
import { ModuleScene } from '@/versions/v1/modules/workflows/ModuleScene';
import { WorkflowsSectionScene } from '@/versions/v1/modules/workflows/WorkflowsSectionScene';
import { WorkflowStepScene } from '@/versions/v1/modules/workflows/WorkflowStepScene';
import { HomeSectionScene } from '@/versions/v1/modules/workflows/HomeSectionScene';
// fork: scenes — customers/service/reports (P5c)
import { CustomersScene } from '@/versions/v1/modules/customers/CustomersScene';
import { PartsFlowScene } from '@/versions/v1/modules/service/PartsFlowScene';
import { PopulationScene } from '@/versions/v1/modules/service/PopulationScene';
import { RemoteSupportScene } from '@/versions/v1/modules/service/RemoteSupportScene';
import { SosReportScene } from '@/versions/v1/modules/reports/SosReportScene';
import { TechniciansScene } from '@/versions/v1/modules/service/TechniciansScene';
// fork: scenes — reports (L3)
import { DeckScene } from '@/versions/v1/modules/reports/DeckScene';
import { ReportsScene } from '@/versions/v1/modules/reports/ReportsScene';
import { RiskEmailScene } from '@/versions/v1/modules/reports/RiskEmailScene';
import { WeeklyStatusScene } from '@/versions/v1/modules/reports/WeeklyStatusScene';
// fork: scenes — integration/help/assets (P5d)
import { AgentsScene } from '@/versions/v1/modules/integration/AgentsScene';
import { DataBrowserScene } from '@/versions/v1/modules/integration/DataBrowserScene';
import { IntegrationSectionScene } from '@/versions/v1/modules/integration/IntegrationSectionScene';
import { OemConnectorsScene } from '@/versions/v1/modules/integration/OemConnectorsScene';
import { NavigationHelpScene } from '@/versions/v1/modules/help/NavigationHelpScene';
import { PlatformMapScene } from '@/versions/v1/modules/help/PlatformMapScene';
import { RolesScene } from '@/versions/v1/modules/help/RolesScene';
import { StructureScene } from '@/versions/v1/modules/help/StructureScene'; // fork(oem/v1.8): WBS outline
import { TourScene } from '@/versions/v1/modules/help/TourScene'; // fork: L8 guided tour
import { AssetsSectionScene } from '@/versions/v1/modules/fleet/AssetsSectionScene';
import { DivisionScene } from '@/versions/v1/modules/fleet/DivisionScene';
import { AppLayout } from './layout';

export function Router() {
  return (
    <Routes>
      <Route path="/login" element={<AuthScene />} />
      <Route path="/signup" element={<SignupScene />} />
      <Route path="/lobby" element={<LobbyScene />} />
      <Route path="/lobby/declined" element={<LobbyDeclinedScene />} />

      <Route element={<AppLayout />}>
        {/* fork: routes — oem (P3 lanes append here) */}
        {/* fork: routes — asset360/approvals/costs */}
        {/*
          `/` is the executive landing. It replaced the foundation's
          WorkspaceChatScene, which stays in the tree for the parity snapshots
          but is no longer reachable from the nav (plan §B, orphaned modules).
        */}
        <Route path="/" element={<Asset360Scene />} />
        <Route path="/approvals" element={<ApprovalsScene />} />
        <Route path="/costs" element={<CostSummaryScene />} />
        {/* end fork: routes — asset360/approvals/costs */}
        {/* fork: routes — issues */}
        <Route path="/issues" element={<IssuesLiveScene />} />
        <Route path="/issues/alerts" element={<AlertsScene />} />
        <Route path="/issues/alerts/:alertId" element={<AlertsScene />} />
        <Route path="/issues/incidents" element={<IncidentsScene />} />
        <Route path="/issues/incidents/:incidentId" element={<IncidentsScene />} />
        <Route path="/issues/routing" element={<RoutingScene />} />
        {/* /fork: routes — issues */}
        {/* fork: routes — fleet/sites */}
        <Route path="/fleet" element={<FleetHealthScene />} />
        <Route path="/priorities" element={<PrioritiesScene />} />
        <Route path="/machines/:machineId" element={<MachineScene />} />
        <Route path="/sites" element={<SitesMapScene />} />
        <Route path="/sites/:mineCode" element={<MineSiteScene />} />
        {/* end fork: routes — fleet/sites */}
        {/* fork: routes — loops/jobs (P5b) */}
        <Route path="/loops" element={<LoopsSectionScene />} />
        <Route path="/loops/:loopId" element={<LoopScene />} />
        {/*
          The job surfaces sit at the top level, not under /workflows: that is
          where `shared/oem-nav.ts`, `shared/oem-routes.ts` (`jobboard`,
          `jobcards`) and the assistant's `EXACT_VIEW` map already point them,
          and the plan's Tier 2 route table spells them the same way. Only the
          case trace lives under /workflows, because it is step 2 of module 03.
          The two /workflows spellings redirect so a link written either way
          lands somewhere.
        */}
        <Route path="/job-board" element={<JobBoardScene />} />
        <Route path="/job-cards" element={<JobCardsScene />} />
        <Route path="/workflows/case-trace" element={<CaseTraceScene />} />
        <Route
          path="/workflows/job-board"
          element={<Navigate to="/job-board" replace />}
        />
        <Route
          path="/workflows/job-cards"
          element={<Navigate to="/job-cards" replace />}
        />
        {/* end fork: routes — loops/jobs */}
        {/* fork: routes — workflows */}
        <Route path="/workflows" element={<WorkflowsSectionScene />} />
        <Route path="/workflows/modules/:moduleId" element={<ModuleScene />} />
        <Route path="/workflows/steps/:stepId" element={<WorkflowStepScene />} />
        {/* Full-mode Home section landing; `section:home` resolves here only in Full. */}
        <Route path="/home" element={<HomeSectionScene />} />
        {/* end fork: routes — workflows */}
        {/* fork: routes — customers/service/reports (P5c)

            Paths follow `shared/oem-routes.ts` and `shared/oem-nav.ts`, which
            both address these five surfaces at the top level (`/technicians`,
            not `/workflows/technicians`). The plan's §B table writes them under
            `/workflows/`, so each also answers there and redirects to the
            canonical path — a deep link from either naming survives. */}
        <Route path="/customers" element={<CustomersScene />} />
        <Route path="/technicians" element={<TechniciansScene />} />
        <Route
          path="/workflows/technicians"
          element={<Navigate to="/technicians" replace />}
        />
        <Route path="/parts-flow" element={<PartsFlowScene />} />
        <Route path="/workflows/parts-flow" element={<Navigate to="/parts-flow" replace />} />
        <Route path="/population" element={<PopulationScene />} />
        <Route path="/workflows/population" element={<Navigate to="/population" replace />} />
        <Route path="/remote-support" element={<RemoteSupportScene />} />
        <Route
          path="/workflows/remote-support"
          element={<Navigate to="/remote-support" replace />}
        />
        <Route path="/reports/sos" element={<SosReportScene />} />
        {/* end fork: routes — customers/service/reports */}
        {/* fork: routes — reports (L3)

            The reports index replaces the old `/reports` → `/reports/sos`
            redirect; `routeForView('reports')` and the `generate_report`
            source chip land here unchanged. A report's address is its kind
            and, for the email and the deck, its mine — see
            `shared/report-catalog.ts` `reportPath()`. */}
        <Route path="/reports" element={<ReportsScene />} />
        <Route path="/reports/weekly/:division" element={<WeeklyStatusScene />} />
        <Route path="/reports/email/:mine" element={<RiskEmailScene />} />
        <Route path="/reports/deck/:mine" element={<DeckScene />} />
        {/* end fork: routes — reports */}
        {/* fork: routes — integration/help/assets */}
        <Route path="/integration" element={<IntegrationSectionScene />} />
        <Route path="/integration/data" element={<DataBrowserScene />} />
        <Route path="/connectors" element={<OemConnectorsScene />} />
        <Route path="/agents" element={<AgentsScene />} />
        <Route path="/assets" element={<AssetsSectionScene />} />
        <Route path="/assets/:divisionId" element={<DivisionScene />} />
        {/* end fork: routes — integration/help/assets */}
        {/* fork: routes — help (L8)

            The bare /help is Help → Guided tour, the demo's help-tour show() target
            and where "End tour" lands; it used to redirect to the
            platform map while the tour was Tier 3. /help/tour answers too, so
            a link spelled after the tab still lands. */}
        <Route path="/help" element={<TourScene />} />
        <Route path="/help/tour" element={<Navigate to="/help" replace />} />
        <Route path="/help/platform-map" element={<PlatformMapScene />} />
        <Route path="/help/structure" element={<StructureScene />} />
        <Route path="/help/navigation" element={<NavigationHelpScene />} />
        <Route path="/help/roles" element={<RolesScene />} />
        {/* end fork: routes — help */}
        <Route path="/changelog" element={<ChangelogScene />} />
        <Route path="/docs/logic" element={<DocsLibraryScene />} />
        <Route path="/docs/logic/:module/:doc" element={<DocsLibraryScene />} />

        {/* fork(oem): the trimmed settings nav is Account / Appearance /
            Notifications — connectors is no longer a tab, so the bare
            /settings redirect has to land on Account. */}
        <Route path="/settings" element={<Navigate to="/settings/account" replace />} />
        <Route path="/settings/connectors/:connectorId" element={<ConnectorDetailScene />} />
        <Route path="/settings/plugins/marketplace" element={<PluginMarketplaceScene />} />
        <Route path="/settings/plugins/:pluginId" element={<PluginDetailScene />} />
        <Route path="/settings/plugins" element={<PluginsScene />} />
        <Route path="/settings/projects/:projectId" element={<ProjectSettingsScene />} />
        <Route
          path="/settings/skills/plugin/:pluginId/:name"
          element={<PluginSkillDetailScene />}
        />
        <Route path="/settings/skills/:slug" element={<SkillDetailScene />} />
        <Route path="/settings/:slug" element={<SettingsRoute />} />

        <Route path="/admin" element={<AdminDashboardScene />} />
        <Route path="/admin/users" element={<UsersScene />} />
        <Route path="/admin/signups" element={<SignupsScene />} />
        <Route path="/admin/projects" element={<ProjectsScene />} />
        <Route path="/admin/connectors" element={<ConnectorsScene />} />
        <Route path="/admin/system-prompt" element={<SystemPromptScene />} />
        <Route path="/admin/predefined-skills" element={<PredefinedSkillsScene />} />
        <Route path="/admin/sandbox-libraries" element={<SandboxLibrariesScene />} />
        <Route path="/admin/embedding-provider" element={<EmbeddingProviderScene />} />
        <Route path="/admin/workspace" element={<WorkspaceScene />} />
        <Route path="/admin/agent-review-inline" element={<AgentReviewInlineScene />} />
        <Route path="/admin/editor-page-flow" element={<EditorPageFlowScene />} />
        <Route path="/admin/api-keys" element={<ApiKeysScene />} />
        <Route path="/admin/service-health" element={<ServiceHealthScene />} />
        <Route path="/admin/system-status" element={<SystemStatusScene />} />
        <Route path="/admin/sso" element={<SsoScene />} />
        <Route path="/admin/maintenance" element={<MaintenanceScene />} />
        <Route path="/admin/ai-models" element={<AiModelsScene />} />
        <Route
          path="/admin/claude-models"
          element={<Navigate to="/admin/ai-models" replace />}
        />
        <Route
          path="/admin/google-models"
          element={<Navigate to="/admin/ai-models" replace />}
        />
        <Route path="/admin/builtin-tools" element={<BuiltinToolsScene />} />
        <Route path="/admin/announcement-banner" element={<AnnouncementBannerScene />} />

        <Route path="/projects" element={<PortfolioScene />} />
        <Route path="/projects/:projectId" element={<ProjectHomeScene />} />
        <Route path="/projects/:projectId/chat" element={<ProjectChatScene />} />
        <Route
          path="/projects/:projectId/workflows"
          element={<ProjectWorkflowsScene />}
        />
        <Route
          path="/projects/:projectId/editor"
          element={<ProjectEditorScene />}
        />
        <Route
          path="/projects/:projectId/dashboards"
          element={<ProjectDashboardsScene />}
        />
        <Route
          path="/projects/:projectId/tasks"
          element={<ProjectTasksScene />}
        />
        <Route path="/projects/:projectId/overview" element={<Navigate to=".." replace />} />

        <Route path="*" element={<NotFoundScene />} />
      </Route>
    </Routes>
  );
}
